var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.activeModule === 'ecolabware-notes')?_c('ecolabware-notes'):_vm._e(),(_vm.activeModule === 'ecolabware-team')?_c('ecolabware-team'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }